import React from "react";

/**
 * Checkbox component - primary color when checked, rounded.
 * Follows UI guidelines: professional, consistent with Input/Button.
 * @see .cursor/ui.md
 */
const Checkbox = ({
  id,
  name,
  checked = false,
  onChange,
  onBlur,
  label,
  disabled = false,
  error = false,
  className = "",
  ...props
}) => {
  return (
    <label
      className={`group inline-flex items-center gap-3 cursor-pointer select-none ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      } ${className}`}
    >
      <span className="relative flex shrink-0">
        <input
          type="checkbox"
          id={id}
          name={name}
          checked={checked}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          className="peer sr-only"
          {...props}
        />
        <span
          className={`block w-5 h-5 rounded border-2 transition-all duration-200 ${
            error
              ? "border-red-500"
              : "border-gray-300 peer-focus:border-primary peer-focus:ring-2 peer-focus:ring-primary/20 group-hover:border-gray-400"
          } ${
            checked
              ? "bg-primary border-primary"
              : "bg-white"
          } ${disabled ? "bg-gray-100" : ""}`}
        >
          {checked && (
            <svg
              className="w-full h-full p-0.5 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={3}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 13l4 4L19 7" />
            </svg>
          )}
        </span>
      </span>
      {label && (
        <span className="text-sm font-medium text-gray-700">{label}</span>
      )}
    </label>
  );
};

export default Checkbox;
